import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["options"]

  connect() {
    // Ensure options visibility is correct when controller connects/reconnects
    const checkbox = this.element.querySelector('input[type="checkbox"]')
    if (checkbox) {
      this.toggleOptions(checkbox.checked)
    }
  }

  toggle(event) {
    const checkbox = event.target
    const form = checkbox.form
    
    // Show/hide notification method options
    this.toggleOptions(checkbox.checked)
    
    // Visual feedback
    checkbox.disabled = true
    
    // Create FormData with only the specific notify_once parameter
    const formData = new FormData()
    formData.append('endpoint[notify_once]', checkbox.checked ? '1' : '0')
    formData.append('endpoint[notify_once_method]', 'email')
    
    // Submit the form via fetch to update the notify_once field
    fetch(form.action, {
      method: "PATCH",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      }
    })
    .then(response => {
      if (response.ok) {
        // Show visual feedback
        this.showFeedback(checkbox.checked)
      } else {
        // Revert checkbox on error
        checkbox.checked = !checkbox.checked
        this.toggleOptions(checkbox.checked)
        this.showError()
      }
    })
    .catch(() => {
      // Revert checkbox on error
      checkbox.checked = !checkbox.checked
      this.toggleOptions(checkbox.checked)
      this.showError()
    })
    .finally(() => {
      checkbox.disabled = false
    })
  }

  changeMethod(event) {
    const radioButton = event.target
    const form = radioButton.form
    
    // Visual feedback
    radioButton.disabled = true
    
    // Create FormData with only the notify_once_method parameter
    const formData = new FormData()
    formData.append('endpoint[notify_once_method]', radioButton.value)
    
    // Submit the form via fetch to update the notify_once_method field
    fetch(form.action, {
      method: "PATCH",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
      }
    })
    .then(response => {
      if (response.ok) {
        // Visual feedback could be added here if needed
        console.log('Notification method updated successfully')
      } else {
        this.showError()
      }
    })
    .catch(() => {
      this.showError()
    })
    .finally(() => {
      radioButton.disabled = false
    })
  }

  toggleOptions(show) {
    if (this.hasOptionsTarget) {
      if (show) {
        this.optionsTarget.classList.remove("hidden")
      } else {
        this.optionsTarget.classList.add("hidden")
      }
    }
  }
  
  showFeedback(enabled) {
    // Create or update the status indicator
    const existingBadge = document.querySelector('.notify-once-badge')
    const container = this.element.closest('.flex')
    
    if (enabled) {
      if (!existingBadge) {
        const badge = document.createElement('div')
        badge.className = 'notify-once-badge inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800'
        badge.innerHTML = `
          <svg class="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
          </svg>
          Will notify once
        `
        container.appendChild(badge)
      }
    } else {
      if (existingBadge) {
        existingBadge.remove()
      }
    }
  }
  
  showError() {
    // Simple error feedback
    const checkbox = this.element.querySelector('input[type="checkbox"]')
    checkbox.style.outline = '2px solid #ef4444'
    setTimeout(() => {
      checkbox.style.outline = ''
    }, 2000)
  }
} 